module.exports = __webpack_public_path__ + "img/ESF-BW-Logo.44f447df.jpg";